import React from "react";
import { Provider } from "react-redux";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import "./index.css";
import App from "./App";
import theme from "./theme";
import { setupStore } from "./redux/store";
import { HashRouter } from "react-router";

import { de } from "date-fns/locale";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

import { createRoot } from "react-dom/client";
const store = setupStore();
const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <Provider store={store}>
          <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={de}>
            <HashRouter>
              <App />
            </HashRouter>
          </LocalizationProvider>
        </Provider>
      </ThemeProvider>
    </StyledEngineProvider>
  </React.StrictMode>,
);
